import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import TablePagination from "@mui/material/TablePagination";
import BasicPagination from "../BasicPagination/basicPagination";

import { getFieldValueFromSearchParams } from "../../../helpers/methods";
import usePaginationWithSearchParams from "../../../hooks/usePaginationWithSearchParams";

function BasicPaginationWithRowsPerPage(props) {
    const { getFilterFieldKey, searchParams } = usePaginationWithSearchParams(props.filterPrefix);

    const { t } = useTranslation();

    // Default to the page number provided as prop, otherwise fallback to the page number from global search params
    const page =
        props.page !== undefined
            ? props.page
            : getFieldValueFromSearchParams(searchParams, getFilterFieldKey(props.pageKey));
    return (
        <TablePagination
            component="div"
            count={props.countRecords}
            page={page}
            onPageChange={props.onPageChange}
            rowsPerPage={props.rowsPerPage}
            onRowsPerPageChange={props.onRowsPerPageChange}
            rowsPerPageOptions={props.rowsPerPageOptions}
            labelRowsPerPage={t("rows_per_page")}
            ActionsComponent={BasicPagination}
            labelDisplayedRows={() => undefined}
            disabled={props.isLoading}
        />
    );
}

BasicPaginationWithRowsPerPage.propTypes = {
    countRecords: PropTypes.number,
    page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    pageKey: PropTypes.string,
    pageSizeKey: PropTypes.string,
    onPageChange: PropTypes.func,
    rowsPerPage: PropTypes.number,
    onRowsPerPageChange: PropTypes.func,
    rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
    filterPrefix: PropTypes.string,
};

BasicPaginationWithRowsPerPage.defaultProps = {
    pageSizeKey: "page_size",
    pageKey: "page",
};

export default BasicPaginationWithRowsPerPage;
